var _g, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9377 2.8125H9.0002L5.54785 7.3125L9.0002 15.75L16.8752 7.3125L12.9377 2.8125Z",
    fill: "#A8AAAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9377 2.8125H9.0002L5.54785 7.3125L9.0002 15.75L16.8752 7.3125L12.9377 2.8125Z",
    fill: "white",
    fillOpacity: 0.2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.0625 2.8125H12.9375L16.875 7.3125L9 15.75L1.125 7.3125L5.0625 2.8125Z",
    stroke: "#A8AAAE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0625 2.8125H12.9375L16.875 7.3125L9 15.75L1.125 7.3125L5.0625 2.8125Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.79341 2.20381C9.60415 1.95712 9.31092 1.8125 9 1.8125C8.68908 1.8125 8.39585 1.95712 8.20659 2.20381L5.05446 6.3125H1.125C0.572715 6.3125 0.125 6.76022 0.125 7.3125C0.125 7.86478 0.572715 8.3125 1.125 8.3125H4.87635L8.07448 16.1287C8.22824 16.5045 8.59397 16.75 9 16.75C9.40603 16.75 9.77176 16.5045 9.92552 16.1287L13.1236 8.3125H16.875C17.4273 8.3125 17.875 7.86478 17.875 7.3125C17.875 6.76022 17.4273 6.3125 16.875 6.3125H12.9455L9.79341 2.20381ZM10.4248 6.3125L9 4.45537L7.57523 6.3125H10.4248ZM7.03729 8.3125L9 13.1093L10.9627 8.3125H7.03729Z",
    fill: "#A8AAAE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.79341 2.20381C9.60415 1.95712 9.31092 1.8125 9 1.8125C8.68908 1.8125 8.39585 1.95712 8.20659 2.20381L5.05446 6.3125H1.125C0.572715 6.3125 0.125 6.76022 0.125 7.3125C0.125 7.86478 0.572715 8.3125 1.125 8.3125H4.87635L8.07448 16.1287C8.22824 16.5045 8.59397 16.75 9 16.75C9.40603 16.75 9.77176 16.5045 9.92552 16.1287L13.1236 8.3125H16.875C17.4273 8.3125 17.875 7.86478 17.875 7.3125C17.875 6.76022 17.4273 6.3125 16.875 6.3125H12.9455L9.79341 2.20381ZM10.4248 6.3125L9 4.45537L7.57523 6.3125H10.4248ZM7.03729 8.3125L9 13.1093L10.9627 8.3125H7.03729Z",
    fill: "white",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamand);
export default __webpack_public_path__ + "static/media/diamand.219cacb354ad3004217040d6cff834e3.svg";
export { ForwardRef as ReactComponent };